<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人列表</el-breadcrumb-item>
        <el-breadcrumb-item>临时地图列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <el-col :span="5" >
                    <el-input placeholder="地图编号" v-model="dataMap.mapNo" class="m-l-30 ell-input"> </el-input>
                </el-col>
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchDataMaps()">查询</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
                 <el-button type="primary" @click="returnMissionRobot()">返回</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="dataMapList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器人编号" prop="robotNo" width="250"></el-table-column>
            <el-table-column label="地图编号" prop="mapNo" width="250"></el-table-column>
            <el-table-column label="使用状态" prop="isUser" width="250">
                <template slot-scope="scope">
                   <span v-if="scope.row.isUser==0" >
                            否
                   </span>
                   <span v-if="scope.row.isUser==1" style="color:blue">
                            是
                   </span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="200"></el-table-column>
            <el-table-column label="操作" prop="" width="400">
                <template slot-scope="scope">
                    <span v-if="scope.row.isUser==1">
                        <el-tooltip effect="dark" content="查看任务点信息" placement="top" :enterable="false"  >  
                            <el-button type="warning"  size="mini" @click="loadInterspersedrecord(scope.row)">临时任务列表</el-button>
                        </el-tooltip>
                    </span>
                    <el-tooltip effect="dark" content="地图信息编辑" placement="top" :enterable="false" v-if="scope.row.institutionType==2" >  
                        <el-button type="primary"  size="mini" @click="editNode(scope.row)">医院地图信息编辑</el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="dataMap.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>


         <!-- 编辑任务点信息 -->
        <el-dialog title="编辑任务点信息"  :visible.sync="editDataMapVisible"  width="50%" @close="editDataMapClose" >
             <template slot="title"> 
                <div style="font-size:25px;color:blue;">编辑任务点信息</div>    
            </template>
                <el-row  >
                    <el-col :span="10" >
                        <span style="font-size:20px;color:#000000;">机器编号:</span><span  style="font-size:20px;color:#67C23A;"> {{editDataMap.robotNo}} </span>
                    </el-col>
                    <el-col :span="10" >
                         <span style="font-size:20px;color:#000000;">地图编号:</span>  <span style="font-size:20px;color:#67C23A;"> {{editDataMap.mapNo}}</span>
                    </el-col>
                </el-row>
                <el-row   >
                    <!-- 用户列表区域 -->
                    <el-table :data="pointinfoList" border   stripe  height="300" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" @cell-click="tabClick"  :row-class-name="tableRowClassName" >
                        <el-table-column label="点位编号" prop="pointNo" width="100"></el-table-column>
                        <el-table-column label="楼栋编号"  width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '楼栋编号'">
                                    <el-input v-model="scope.row.buildingNo" maxlength="150" placeholder="楼栋编号" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                                </span>
                                <span v-else>{{ scope.row.buildingNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="楼层编号" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '楼层编号'">
                                    <el-input v-model="scope.row.floorNo" maxlength="150" placeholder="楼层编号" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                                </span>
                                <span v-else>{{ scope.row.floorNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="房间号" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '房间号'">
                                    <el-input v-model="scope.row.roomNo" maxlength="150" placeholder="房间号" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                                </span>
                                <span v-else>{{ scope.row.roomNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="房间备注信息"  width="360">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '房间备注信息'">
                                    <el-input v-model="scope.row.roomInfo" maxlength="150" placeholder="房间备注信息" size="mini" @blur="inputBlur" class="ell-input"/>
                                </span>
                                <span v-else>{{ scope.row.roomInfo }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row   :gutter='20' >
                    <el-col :span="14">
                    　<canvas id="mycanvas1" class="mycanvasDiv" alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                    </el-col>
                </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDataMapVisible = false">取 消</el-button>
                <el-button type="primary" @click="editDataMapData()">确 定</el-button>
            </span>
        </el-dialog>
       
       
    </el-card >
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'machine',
  data(){
      return {
          dataMap :{
              robotNo:'',
              mapNo:'',
              num:1,
          },
          editDataMapRules:{},
          dataMapList:[],
          total:0,
          editDataMapVisible:false,
          editDataMap:{},
          resolution:'',
          origin_x:'',
          origin_y:'',
          pointinfoList:[],
          tabClickIndex: null, // 点击的单元格
          tabClickLabel: '', // 当前点击的列名
          formData:new FormData(),
          robotNo:'',
          viewDataMap:{},
          viewPointinfoList:[
            {
              pointNo:'',  
              buildingNo:'',
              floorNo:'',
              roomNo:'',
              roomInfo:'',
              time:'',
            }    
          ],
      }
  },
   computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
   //生命周期函数
  created(){
     this.searchDataMaps();
  },
  methods:{
        //清理图片缓存
        clearCanvas(){
            var c=document.getElementById("mycanvas1");
            if(c==undefined){
                return;
            }
            var cxt=c.getContext("2d");
            cxt.clearRect(0,0,c.width,c.height);
        },
        loadInterspersedrecord(obj){
             this.$router.replace({path: '/temporary?robotNo='+obj.robotNo+"&mapId="+obj.id})
        },
        returnMissionRobot(){
              this.$router.replace({path: '/robot'})
        },
        tableRowClassName({ row, rowIndex }) {
            // 把每一行的索引放进row
            row.index = rowIndex
        },
        tabClick(row, column, cell, event) {
            this.tabClickIndex = row.index
            this.tabClickLabel = column.label
            console.log(this.tabClickIndex)
        },
        // 失去焦点初始化
        inputBlur(row, event, column) {
            this.tabClickIndex = null
            this.tabClickLabel = ''
       },
       searchDataMaps(){
            var check = /[`~!@#$%^&*()\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.dataMap.robotNo)||check.test(this.dataMap.mapNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.robotNo=this.$route.query.robotNo;
            this.$http.get('map/selectRobots',{params :{ robotNo : this.robotNo,mapNo : this.dataMap.mapNo,pageNum :this.dataMap.num }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.dataMapList=response.data.result.data
                        this.total=response.data.result.total
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })

       },
       editNode(obj){
            this.editDataMap=obj
            this.editDataMapVisible=true
            let  that=this
            this.$http.get('map/findPointInfos',{params :{ robotNo : obj.robotNo,mapNo : obj.mapNo }})
            .then(response => {
                    if (response.data.code === 200) {
                        if(response.data.result.length>0){
                            this.pointinfoList=response.data.result
                        }
                        that.$nextTick(() => {
                            this.downloadOFile(this.editDataMap.orginUrl,this.editDataMap,"mycanvas1");
                        });
                       
                    }
                }).catch(failResponse => {
                
            })
            
       },

       clearParams(){
           this.dataMap.robotNO='';
           this.dataMap.mapNo='';
       },
       handleCurrentChange(page){
            this.dataMap.num=page;
            this.searchDataMaps();
       },
       editDataMapData(){
            let params = {mapNo:this.editDataMap.mapNo,robotNo:this.editDataMap.robotNo, pointinfos : this.pointinfoList}
            this.$http.post('/map/addPointInfo',JSON.stringify(params)) .then(response => {
                if (response.data.code === 200) {
                    this.editDataMapVisible=false;
                   return this.$message.success(response.data.message) 
                }else{
                    return this.$message.error(response.data.message) 
                }
                }).catch(failResponse => {

            })
       },
       editDataMapClose(){
           this.editDataMap=[];
           this.pointinfoList=[];
           this.tabClickIndex=null
           this.tabClickLabel='';
           this.clearCanvas();
       },
       // 下载原点文件
       downloadOFile(url,dataMap,mycanva) {
        console.log('下载原点文件', url)
         this.$http.get(window.location.origin+url)
            .then(res => {
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                that.origin_y = originArr[1]
                console.log(dataMap.mapPngUrl)
                that.doDraw(dataMap.mapPngUrl,dataMap,mycanva)
            }  
            }).catch(res => {
                
            })
        },
         // imageUrl为后台提供图片地址
        doDraw(imageUrl,dataMap,mycanva) {
            // 获取canvas
            var canvas = document.getElementById(mycanva)
            // 由于弹窗，确保已获取到
            var a = setInterval(() => {
            // 重复获取
                canvas = document.getElementById(mycanva)
                if (!canvas) {
                    return false
                } else {
                clearInterval(a)
                // 可以理解为一个画笔，可画路径、矩形、文字、图像
                var context = canvas.getContext('2d')
                var scale = window.devicePixelRatio
                context.scale(scale, scale)
                var img = new Image()
                img.src = imageUrl
                const that = this
                // 加载图片
                img.onload = function() {
                    if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    canvas.setAttribute('width', img.width)
                    canvas.setAttribute('height', img.height)
                    that.imageWidth = canvas.width
                    that.imageHeight = canvas.height
                    that.gcanvas = canvas
                    // 绘制图片
                    context.drawImage(img, 0, 0, img.width, img.height)
                    //起始点坐标计算公式
                    var x1 = (0 - that.origin_x) / that.resolution
                    var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                    //画出原点坐标
                    that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                    that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                    //画轨迹
                    that.downloadRoadFile(dataMap.roadUrl,dataMap)
                    }
                  }
                }
            }, 10)
        },
        // 画线doDra
        doDrawLine(context, x1, y1, x2, y2, color, line) {
        context.beginPath()
        context.moveTo(x1, y1)
        context.lineTo(x2, y2)
        context.strokeStyle = color
        context.lineWidth = line
        context.stroke()
        },
        //根据轨迹文件画图
        downloadRoadFile(url,dataMap) {
            console.log('加载xml文件')
            this.$http.get(window.location.origin+url)
                .then(res => {
                        const blob = new Blob([res.data])
                        const reader = new FileReader()
                        const that = this
                        reader.readAsText(blob, 'utf-8')
                        reader.onload = function() {
                        var xmlList = reader.result.split('<vertex')
                        var lineXmlList = reader.result.split('<edge')
                        var tempList = []
                        var lineist = []
                        for (var i = 1; i < xmlList.length; i++) {
                            var tempString = xmlList[i];
                            var pointin=null;
                            if(tempString.indexOf("visible")== -1 ){
                                var Id = tempString.substring(tempString.indexOf('id="') + 4, tempString.indexOf('" x='))
                                var X = tempString.substring(tempString.indexOf('x="') + 3, tempString.indexOf('" y="'))
                                var Y = tempString.substring(tempString.indexOf('y="') + 3, tempString.indexOf('" yaw="'))
                                var name = tempString.substring(tempString.indexOf('Name="') + 6, tempString.indexOf('" />'))
                                tempList.push({ Id, X, Y })
                                pointin={ "pointNo" : Id*1}
                            }else{
                                var Id = tempString.substring(tempString.indexOf('id="') + 4, tempString.indexOf('" visible='))
                                var X = tempString.substring(tempString.indexOf('x="') + 3, tempString.indexOf('" y="'))
                                var Y = tempString.substring(tempString.indexOf('y="') + 3, tempString.indexOf('" />'))
                                tempList.push({ Id, X, Y })
                                pointin={ "pointNo" : Id*1}
                            }    
                            //添加参考点
                            if( that.pointinfoList.length==0){
                                that.pointinfoList.push(pointin)
                            }else{
                                if(tempList.length>that.pointinfoList.length){
                                    that.pointinfoList.push(pointin)
                                } 
                            }                        
                        }
                        for (var k = 1; k < lineXmlList.length; k++) {
                            var lineString = lineXmlList[k]
                            var lid = lineString.substring(lineString.indexOf('id="') + 4, lineString.indexOf('" src_id='))
                            var src_id = lineString.substring(lineString.indexOf('src_id="') + 8, lineString.indexOf('" dst_id='))
                            var dst_id = lineString.substring(lineString.indexOf('dst_id="') + 8, lineString.indexOf('" directional='))
                            lineist.push({ lid, src_id, dst_id })
                        }
                        dataMap.dotList = tempList
                        dataMap.lineList = lineist
                        for (var j = 0; j < lineist.length; j++) {
                            var context = that.gcanvas.getContext('2d')
                            var scale = window.devicePixelRatio
                            context.scale(scale, scale)
                            var m = parseInt(lineist[j].src_id)
                            var n = parseInt(lineist[j].dst_id)
                            var x = parseFloat(dataMap.dotList[m].X)
                            var y = parseFloat(dataMap.dotList[m].Y)
                            x = (x - that.origin_x) / that.resolution
                            y = that.imageHeight - (y - that.origin_y) / that.resolution
                            var x2 = parseFloat(dataMap.dotList[n].X)
                            var y2 = parseFloat(dataMap.dotList[n].Y)
                            x2 = (x2 - that.origin_x) / that.resolution
                            y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                        }
                        for (var l = 0; l < tempList.length; l++) {
                            var context1 = that.gcanvas.getContext('2d')
                            var scale1 = window.devicePixelRatio
                            context1.scale(scale1, scale1)
                            var x1 = parseFloat(dataMap.dotList[l].X)
                            var y1 = parseFloat(dataMap.dotList[l].Y)
                            x1 = (x1 - that.origin_x) / that.resolution
                            y1 = that.imageHeight - (y1 - that.origin_y) / that.resolution
                            that.doDrawSicle(context1, x1, y1, 'green', 3,l)
                        }
                    
                    }
                }).catch((error) => {
                    console.log(error)
                })
            },
        //机器人原点
        doDrawSiclePath(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line,index) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.font="15px lighter arial";
            context.fillText(index,x,y);
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },

  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.elll-input {
    width: 100px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 

</style>


// WEBPACK FOOTER //
// src/components/robot/TemporaryMap.vue